var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "supportGradient",
    x1: 12,
    y1: 54,
    x2: 52,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE8B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "supportAccent",
    x1: 22,
    y1: 24,
    x2: 45,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE8B5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 40,
    height: 30,
    rx: 4,
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 58H41",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54V58",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37V34C21 27.9 26.2 23 32 23C37.8 23 43 27.9 43 34V37",
    stroke: "url(#supportAccent)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37H18C16.3 37 15 38.3 15 40V44C15 45.7 16.3 47 18 47H21V37Z",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37H46C47.7 37 49 38.3 49 40V44C49 45.7 47.7 47 46 47H43V37Z",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47C42 51 38.5 53 34 53",
    stroke: "url(#supportAccent)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 17,
    r: 7,
    stroke: "url(#supportGradient)",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17H38",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12V22",
    stroke: "url(#supportGradient)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg09);
export default __webpack_public_path__ + "static/media/img-09.d82e1bb7df77c0a4c7e5b39256d845a6.svg";
export { ForwardRef as ReactComponent };